import { observer } from 'mobx-react-lite';
import Image from 'next/image';

import type { SwapCategory } from '@/utils/constants';
import { Action } from '@/utils/constants';

export type PlanSwapBannerProps = {
  category?: SwapCategory;
  action: Action;
  back: () => void;
};

export const PlanSwapBanner: React.FC<PlanSwapBannerProps> = observer(
  ({ action, back }) => {
    let text = '';

    if (action === Action.SWAP_ITEM) {
      text = 'Select a replacement';
    } else if (action === Action.ADD_ITEM) {
      text = 'Add an item';
    } else if (action === Action.ADD_EXTRA) {
      text = 'Add an extra item';
    }

    return (
      <div id="swap-banner" className="bg-black text-white">
        <div className="container relative flex items-center p-3 font-interMedium lg:px-0">
          <div className="">
            <button id="close" className="flex items-center" onClick={back}>
              <Image
                id="back"
                src="https://www.datocms-assets.com/81001/1706494214-arrow_back.svg"
                alt="back"
                width={15}
                height={15}
              />
              <span className="hidden whitespace-nowrap pl-4 md:flex md:pl-1">
                Back
              </span>
            </button>
          </div>
          <div></div>
          <div className="flex w-full justify-center text-sm md:text-base">
            <span id="plan-text" className="">
              {text}
            </span>
          </div>
        </div>
      </div>
    );
  },
);
